import React from "react";
import { RaiseColors } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var VARIANT_PROPS = {
  proposalCard: {
    backgroundColor: RaiseColors.gray100,
    width: 184,
    height: 116,
    borderRadius: 4,
    fontSize: 40
  }
};
var BuildingFallbackImage = function BuildingFallbackImage(_ref) {
  var _ref2;
  var variant = _ref.variant,
    backgroundColor = _ref.backgroundColor,
    color = _ref.color,
    width = _ref.width,
    height = _ref.height,
    borderRadius = _ref.borderRadius,
    _ref$opacity = _ref.opacity,
    opacity = _ref$opacity === void 0 ? 1 : _ref$opacity,
    fontSize = _ref.fontSize;
  var vp = variant ? VARIANT_PROPS[variant] : undefined;
  var resolvedWidth = width !== null && width !== void 0 ? width : vp === null || vp === void 0 ? void 0 : vp.width;
  var resolvedHeight = height !== null && height !== void 0 ? height : vp === null || vp === void 0 ? void 0 : vp.height;
  var resolvedBorderRadius = (_ref2 = borderRadius !== null && borderRadius !== void 0 ? borderRadius : vp === null || vp === void 0 ? void 0 : vp.borderRadius) !== null && _ref2 !== void 0 ? _ref2 : 4;
  var resolvedFontSize = fontSize !== null && fontSize !== void 0 ? fontSize : vp === null || vp === void 0 ? void 0 : vp.fontSize;
  var resolvedBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : vp === null || vp === void 0 ? void 0 : vp.backgroundColor;
  return /*#__PURE__*/_jsx("div", {
    className: "fa-kit fa-city-two",
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: resolvedWidth,
      width: resolvedWidth,
      height: resolvedHeight,
      borderRadius: resolvedBorderRadius,
      backgroundColor: resolvedBackgroundColor || RaiseColors.pastelPurple,
      color: color || RaiseColors.midnight,
      opacity: opacity,
      fontSize: resolvedFontSize
    }
  });
};
export default BuildingFallbackImage;